import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=42c9603d&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=42c9603d&prod&scoped=true&lang=scss"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=42c9603d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9603d",
  null
  
)

export default component.exports